import '../../style/base.css';
import '../../overlay/index.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../../cell/index.css';
import '../../popup/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/dropdown-item/style/index.js
// module id = 187
// module chunks = 7